export const DEX_LP_DETAILS_WIDGET_TYPE_ID = 'DexLpDetailsWidget';
